
/**
 * Component class
 */
import {App} from "app/Resources/assets/js/app";

export class Component {
  /**
   * Should the component load.
   *
   * @return {boolean}
   */
  public static shouldLoad(): boolean
  {
    return true;
  }


  public constructor(
    protected app: App
  ) { }

  public load() {

  }

  public unload() {

  }

  public register() {

  }
}



// WEBPACK FOOTER //
// ./~/source-map-loader!./app/Resources/assets/js/components/base.ts